import { Injectable } from '@angular/core';
import { ApiClientProvider } from '../../../common';
import { VehiclesApiClient } from './vehicles.api.client';
import { VehiclesInMemoryApiClient } from './vehicles.api.inmemory.client';
import { IVehiclesApiClient } from './i-vehicles-api.client';

@Injectable({
  providedIn: 'root'
})
export class VehiclesApiClientProvider extends ApiClientProvider<IVehiclesApiClient> {
  constructor(
    private client: VehiclesApiClient,
    private inMemoryClient: VehiclesInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IVehiclesApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IVehiclesApiClient {
    return this.client;
  }
}
